/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import clsx from 'clsx';
import {Link} from 'react-router-dom';
import {useLocation} from 'react-router';
import {Tooltip, OverlayTrigger} from 'react-bootstrap';
import {checkIsActive, KTSVG} from '../../../helpers';
import {useLayout} from '../../core';

type Props = {
  to: string;
  title: string;
  icon?: string;
  fontIcon?: string;
  className?: string;
  hasBullet?: boolean;
  bsTitle?: string;
  outside?: boolean;
  isMenuOpen?: boolean;
  badge?: number;
};

const AsideMenuItem: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  className,
  bsTitle,
  outside = false,
  hasBullet = false,
  isMenuOpen = false,
  badge,
}) => {
  const {pathname} = useLocation();
  const isActive = checkIsActive(pathname, to);
  const {config} = useLayout();
  const {aside} = config;

  return (
    <OverlayTrigger
      placement='right'
      delay={{show: 250, hide: 400}}
      overlay={(props) => (
        <Tooltip
          className={`opacity-${bsTitle ? 100 : 0}`}
          id='button-tooltip'
          {...props}
        >
          {bsTitle}
        </Tooltip>
      )}
    >
      <div className={clsx('menu-item', isActive && 'here show', className)}>
        {outside ? (
          <a
            href={to}
            target='_blank'
            className={clsx('menu-link menu-center', {active: isActive})}
          >
            {fontIcon && aside.menuIcon === 'font' && (
              <span className='menu-icon me-0'>
                <i className={clsx('bi', fontIcon, 'fs-2')}></i>
              </span>
            )}
          </a>
        ) : (
          <>
            <Link
              className={clsx('menu-link menu-center', {active: isActive})}
              to={to}
              data-bs-toggle='tooltip'
              data-bs-trigger='hover'
              data-bs-dismiss='click'
              data-bs-placement='right'
              data-bs-original-title={bsTitle}
            >
              {hasBullet && (
                <span className='menu-bullet'>
                  <span className='bullet bullet-dot'></span>
                </span>
              )}
              {icon && aside.menuIcon === 'svg' && (
                <span className='menu-icon'>
                  <KTSVG path={icon} className='svg-icon-2' />
                </span>
              )}

              <span
                className={`menu-icon me-0 ${isMenuOpen ? 'w-100 ps-5' : ''}`}
              >
                <span className='position-relative d-inline-flex'>
                  <i className={clsx('bi', fontIcon, 'fs-2')}></i>
                  {badge != null && badge > 0 && (
                    <span
                      className='position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger'
                      style={{fontSize: '0.6rem', zIndex: 2}}
                    >
                      {badge > 99 ? '99+' : badge}
                    </span>
                  )}
                </span>
                {isMenuOpen && (
                  <span className='menu-title ms-5 text-white'>{title}</span>
                )}
              </span>
            </Link>
            {children}
          </>
        )}
      </div>
    </OverlayTrigger>
  );
};

export {AsideMenuItem};
